var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 18.75H34.875L28.625 12.5H13C9.5625 12.5 6.75 15.3125 6.75 18.75V31.25H69.25V25C69.25 21.5625 66.4375 18.75 63 18.75Z",
    fill: "#686766"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18.75H13C9.5625 18.75 6.75 21.5625 6.75 25V56.25C6.75 59.6875 9.5625 62.5 13 62.5H63C66.4375 62.5 69.25 59.6875 69.25 56.25V25C69.25 21.5625 66.4375 18.75 63 18.75Z",
    fill: "#999898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderGrey);
export default __webpack_public_path__ + "static/media/folder_grey.1bdd1b047230b8ad14e73284748fb519.svg";
export { ForwardRef as ReactComponent };